var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _rect, _rect2, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHomepageIconBo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M16.004 48.005V4.755c0-1.651 1.354-2.994 3.02-2.994h31.884c1.666 0 3.02 1.343 3.02 2.995v43.249c0 1.652-1.354 2.995-3.02 2.995H19.024c-1.666 0-3.02-1.343-3.02-2.995z",
    fill: "#291475"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 46.514V3.264C14 1.614 15.354.27 17.02.27h31.884c1.666 0 3.02 1.343 3.02 2.995v43.249c0 1.652-1.354 2.995-3.02 2.995H17.02c-1.666 0-3.02-1.343-3.02-2.995z",
    fill: "#ED1B2E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.294 46.861V2.921l-32.669-.002-.001 43.941 32.67.001z",
    fill: "#FEFFFA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.78 7.712H18.356v3.833H35.78V7.712z",
    fill: "#B0B0B0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M45.363 13.462H18.356v3.833h27.007v-3.833z",
    fill: "#B0B0B0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.78 25.136H18.356v3.834H35.78v-3.834z",
    fill: "#B0B0B0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M45.363 30.886H18.356v3.833h27.007v-3.833z",
    fill: "#B0B0B0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M51.924 2.459l-.007 44.867a2.187 2.187 0 01-2.2 2.183H16.2c-1.211 0-2.2-.98-2.2-2.183V45.58l31.647.007c1.219 0 2.2-.98 2.2-2.19L47.856.27h1.868c1.212 0 2.2.98 2.2 2.189z",
    fill: "#291475"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M1.223 4.464l.713-.386.712-.386a1.984 1.984 0 012.698.8l3.966 7.32.222.402L21.62 34.533l.012.14.308 3.812.235 2.954-2.34-1.805-3.026-2.337-.11-.081L4.604 14.901l-.865-1.598L.422 7.182a2.012 2.012 0 01.801-2.718z",
    fill: "#291475"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4.784 2.825l-1.42.774a1.993 1.993 0 00-.801 2.703l16.28 30.043.11.08 3.026 2.338 2.34 1.805-.236-2.954-.307-3.813-.013-.14L7.483 3.619a1.998 1.998 0 00-2.7-.793z",
    fill: "#ED1B2E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.799 9.752l.865 1.597-4.917 2.676-.866-1.597L10.8 9.75z",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M4.784 2.825l-1.419.774a1.993 1.993 0 00-.802 2.703l3.316 6.12 4.919-2.677-3.317-6.12a1.99 1.99 0 00-2.697-.8z",
    fill: "#ED1B2E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M23.767 33.805l-4.814 2.62 3.02 2.336 2.343 1.813-.235-2.953-.314-3.816z",
    fill: "#FFDF8C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M24.081 37.62l-2.108 1.14 2.343 1.814-.235-2.953z",
    fill: "#000"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M4.071 3.21l-.713.387a1.993 1.993 0 00-.802 2.702l16.28 30.043.11.081 3.027 2.338 2.34 1.804L4.07 3.211z",
    fill: "#ED1B2E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.19,
    x: 37.896,
    y: 29.608,
    width: 26.136,
    height: 26.136,
    rx: 6,
    transform: "rotate(-.09 37.896 29.608)",
    fill: "#1B365D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 36.091,
    y: 27.808,
    width: 26.136,
    height: 26.136,
    rx: 6,
    transform: "rotate(-.09 36.09 27.808)",
    fill: "#ED1B2E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#homepageIcon_BO_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M48.095 48.428l-6-5.982a.922.922 0 01-.003-1.303l1.302-1.306a.922.922 0 011.303-.002l4.043 4.03 8.631-8.658a.922.922 0 011.304-.002l1.305 1.301c.36.36.362.943.002 1.304L49.4 48.426a.922.922 0 01-1.304.002z",
    fill: "#291475"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.879 45.962l-5.797-5.78a.89.89 0 01-.002-1.259l1.257-1.26a.89.89 0 011.26-.003l3.905 3.893 8.338-8.364a.89.89 0 011.26-.002l1.261 1.257a.89.89 0 01.002 1.26L49.138 45.96a.89.89 0 01-1.26.002z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "homepageIcon_BO_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(-.089 20221.935 -26101.332)",
    d: "M0 0h19.882v19.521H0z"
  })))));
}

export default SvgHomepageIconBo;